<template>
    <div>
        <p>
            O estilo da Chico Rei pode ser resumido em “clean colorido”. Ao mesmo tempo, buscamos um
            resgate de elementos carregados de nostalgia e características vintage. Mas eles devem
            ser utilizados com cuidado: são acessórios para a construção de narrativas, mas não
            devem conflitar com os elementos principais.
        </p>
        <p>
            As camisetas da Chico Rei são ricas em histórias e têm grande potencial para a criação
            de momentos incríveis. Isso pode ser explorado nos elementos de composição, sabendo que
            os protagonistas são as camisetas e quem as veste.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'BrandBookElements',
    };
</script>
